/* eslint-disable no-debugger */
import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import { isValidITIN, isValidEIN } from '@usas/ui-web/utils/validation';
import { isValid5DigitZip, isValid9DigitZip } from '@usas/ui-web/utils/validation';

import Constants from "@usas/ui-web/utils/Constants";

export const localValidate = (formState) => {
  let errors = {};

  if (formState.organizationTypeId === Constants.DEFAULT_ID) {
    errors.organizationTypeId = 'Organization Type is required';
  }

  if (formState.organizationName.trim() === '') {
    errors.organizationName = 'Organization Name is required'
  }

  if (formState.organizationCode.trim() === '') {
    errors.organizationCode = 'Organization Code is required'
  }

  if (formState.lscId === Constants.DEFAULT_ID) {
    errors.lscId = 'LSC is required'
  }

  if (formState.address1.trim() === '') {
    errors.address1 = 'Address is required'
  }

  if (formState.city.trim() === '') {
    errors.city = 'City is required'
  }


  if (formState.stateCode === '-1' || formState.stateCode === -1 || formState.stateCode.trim() === '') {
    errors.stateCode = 'State is required and must be valid';
  }

  if (formState.postalCode.trim() === '') {
    errors.postalCode = 'Postal Code is required'
  } else if (!isValid5DigitZip(formState.postalCode.trim()) && !isValid9DigitZip(formState.postalCode.trim())) {
      // addressError = true;
      errors.postalCode = 'Zip Code must be 5 digits, or 9 digits in XXXXX-XXXX format';
    }

  if (formState.legalEntityTypeId === Constants.DEFAULT_ID) {
    errors.legalEntityTypeId = 'Legal Entity Type is required'
  }

  if (formState.legalEntityName.trim().length === 0) {
    errors.legalEntityName = 'Legal Entity Name is required'
  } else if (formState.legalEntityName.trim().length > 100) {
    errors.legalEntityName = 'Legal Entity Name cannot exceed 100 characters'
  }

  if (formState.legalEntityTaxId.trim().length === 0) {
    errors.legalEntityTaxId = 'Legal Entity Tax Id is required'
  }
  else if (!isValidITIN(formState.legalEntityTaxId.trim()) && !isValidEIN(formState.legalEntityTaxId.trim())) {
    errors.legalEntityTaxId = 'Legal Entity Tax Id must be in ITIN (XXX-XX-XXXX) or EIN (XX-XXXXXXX) format'
  }

  if (formState.registrationSignature.trim().length === 0) {
    errors.registrationSignature = 'Registration Signature is required';
  }

  return errors;
};

const serverValidate = async (formState) => {
  let errors = {};

  const memberIdForUrl = formState.memberId ? encodeURIComponent(formState.memberId) : 'NaN';

  let isCoachRole = false;
  if (formState.coachRoleIds) {
    isCoachRole = formState.coachRoleIds.some(x => x === formState.selectedOrgRoleId);
  }

  const url = `/Person/memberId/${memberIdForUrl}/NonAthlete/GoodStanding?isCoachRole=${isCoachRole}`;
  await PersonHttpHelper(url, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      }
      else {
        if (objData.isInGoodStanding === false || !(objData.personId)) {
          errors.apiError = "This member is not in good standing. Only members in good standing can be added as organization staff";
        } else {
          formState.personId = objData.personId;
        }
      }
    })
    .catch((e) => {
      errors.apiError = 'Staff Member Id is not valid'
    });

  return errors;
};

const NewOrganizationRegistrationValidation = async (formState) => {
  let errors = localValidate(formState);

  if (!errors || Object.keys(errors).length === 0) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
}

export default NewOrganizationRegistrationValidation;